import "./styles/game.css";
import { Game } from "./core/Game";

const canvas = document.querySelector<HTMLCanvasElement>("#game-canvas");
const uiRoot = document.querySelector<HTMLElement>("#ui-root");
if (!canvas || !uiRoot) throw new Error("Elemen permainan tidak ditemui.");

new Game(canvas, uiRoot).start();
